module.exports = __webpack_public_path__ + "img/person-badge.5f481b26.svg";